import React, {Component} from 'react';
import {connect} from 'react-redux';
import {FieldArray} from 'redux-form';
import {Card, Dropdown, Table, Dimmer, Icon} from 'semantic-ui-react';
import {pageSizes} from '../../../../common/constants/lists';
import {Actions} from '../../../../common/actions';
import {getTotalAmount, getTotalWeight} from './utils';
import TablePaginator from '../../../../common/components/tablePaginator';
import ItemsTable from './itemsTable';

class InvoiceTable extends Component {
  constructor(props) {
    super(props);
    this.onPageSizeClick = this.onPageSizeClick.bind(this);
    this.onPageClick = this.onPageClick.bind(this);
    this.renderTable = this.renderTable.bind(this);
  }

  onPageClick(value) {
    const {valid} = this.props;
    if (!valid) {
      this.props.addMessageBoxError(
        'Llene todos los campos requeridos antes de cambiar de página'
      );
      return;
    }
    this.props.changeDetailsInInvoicesListPage(value);
  }

  onPageSizeClick(event, data) {
    const {valid} = this.props;
    if (!valid) {
      this.props.addMessageBoxError(
        'Llene todos los campos requeridos antes de cambiar los items por página'
      );
      return;
    }
    this.props.changeDetailsInInvoicesListPageSize(data.value);
  }

  addItem(fields) {
    const {pageNumber, pageSize, itemsCount, valid} = this.props;
    const pagesCount = Math.ceil(itemsCount / pageSize);
    const lastPage = pagesCount === 0 ? 0 : pagesCount - 1;

    if (pageNumber !== lastPage && !valid) {
      this.props.addMessageBoxError(
        'Llene todos los campos requeridos antes de agregar un nuevo item'
      );
      return;
    }
    fields.push({});
    this.props.addItemInLastPage(lastPage);
  }

  checkDetailsLikeRequiredField(value) {
    return value && value.length ? null : 'Debe agregar al menos un item';
  }

  renderPagination() {
    const {pageNumber, pageSize, itemsCount} = this.props;

    if (itemsCount <= pageSize) {
      return null;
    }
    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.onPageSizeClick}
                />
              </span>
              <TablePaginator
                itemsCount={itemsCount}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onPageClick}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  renderTable({fields}) {
    const {invoice, invoiceStatus, pageNumber, pageSize} = this.props;
    const editingAllowedOfInvoice =
      !invoice || (invoice && invoiceStatus === 'I');
    const allItems = fields.getAll() || [];
    const itemsByPage = allItems.slice(
      pageNumber * pageSize,
      (pageNumber + 1) * pageSize
    );
    const amount = getTotalAmount(allItems);
    const totalWeight = getTotalWeight(allItems);

    return (
      <div>
        <Table striped className='toyota-grid'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center'>#</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Caja No.</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Pedido No.</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Item No.</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Parte No.</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>
                Nombre Parte
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Cant.</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>
                Precio Unitario
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>
                Valor Total
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Peso Neto</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Peso Total</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Acciones</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            <ItemsTable
              fields={fields}
              allItems={allItems}
              invoice={invoice}
              invoiceStatus={invoiceStatus}
              itemsByPage={itemsByPage}
              amount={amount}
              totalWeight={totalWeight}
            />
          </Table.Body>

          {this.renderPagination()}
        </Table>

        {editingAllowedOfInvoice && (
          <div className='addItem' onClick={() => this.addItem(fields)}>
            <Icon name='add' />
            <strong>AGREGAR REGISTRO</strong>
          </div>
        )}
      </div>
    );
  }

  renderErrors(errors) {
    return errors.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.row}</Table.Cell>
          <Table.Cell textAlign='center'>{element.message}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderErrorsOrTable() {
    const {errors} = this.props;
    if (errors.length) {
      return (
        <Table striped className='toyota-grid'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center'>Fila</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Errores</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>{this.renderErrors(errors)}</Table.Body>
        </Table>
      );
    }
    return (
      <FieldArray
        name='detail'
        component={this.renderTable}
        validate={this.checkDetailsLikeRequiredField}
      />
    );
  }

  render() {
    const {saving, cancelling} = this.props;
    return (
      <Card fluid raised className='primary-content'>
        {(saving || cancelling) && <Dimmer active inverted />}
        {this.renderErrorsOrTable()}
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  const {pageNumber, pageSize, values} = state.form.invoice;

  return {
    'saving': state.form.invoice.saving,
    'cancelling': state.form.invoice.cancelling,
    'pageNumber': pageNumber ? pageNumber : 0,
    'pageSize': pageSize ? pageSize : 0,
    'itemsCount': values && values.detail ? values.detail.length : 0,
  };
};

const {
  changeDetailsInInvoicesListPage,
  changeDetailsInInvoicesListPageSize,
  addItemInLastPage,
  addMessageBoxError,
} = Actions;

export default connect(mapStateToProps, {
  changeDetailsInInvoicesListPage,
  changeDetailsInInvoicesListPageSize,
  addItemInLastPage,
  addMessageBoxError,
})(InvoiceTable);
